import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import React from 'react'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { ScrollWrap } from './scroll-wrapper.styles'

const ScrollWrapper = (props) => {
  const {
    minCardWidth = 240,
    scrollItems,
    keyField,
    children,
  } = props

  const total = scrollItems.length
  const scrollThreshold = total > 1 ? total * minCardWidth - 32 : null
  const shouldScroll = useMediaQuery(`(max-width: ${scrollThreshold}px)`)
  const gridWidth = shouldScroll ? total * minCardWidth : null
  let xsCol = 3
  let smCol = 3

  if (total > 1) {
    xsCol = 4 * xsCol / total
    smCol = 4 * smCol / total
  }

  if (total === 1) {
    xsCol = 12
    smCol = 6
  }

  return (
    <ScrollWrap max={scrollThreshold}>
      <Box width={gridWidth}>
        <Grid
          container
          display="flex"
          spacing={3}
        >
          {scrollItems.map(item => (
            <Grid
              item
              xs={xsCol}
              sm={smCol}
              md={3}
              key={item[keyField]}
            >
              {children(item)}
            </Grid>
          ))}
        </Grid>
      </Box>
    </ScrollWrap>
  )
}

ScrollWrapper.propTypes = {
  minCardWidth: PropTypes.number,
  scrollItems: PropTypes.array.isRequired,
  keyField: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
}

export default ScrollWrapper
